import { render, staticRenderFns } from "./LmLeaFletMapBuilderUi.vue?vue&type=template&id=2b40b20a"
import script from "./LmLeaFletMapBuilderUi.vue?vue&type=script&lang=js"
export * from "./LmLeaFletMapBuilderUi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports